export enum LogType {
  ADDED = 'Cadastro',
  UPDATED = 'Atualização',
  DELETED = 'Exclusão',
  CANCELED = 'Cancelamento',
  VIEWED = 'Visualização',
  PRINTED = 'Impressão',
}
